import parseSiren from 'siren-parser';
import { entityStore, useAsyncFetch, useStore } from '~/runtime';

const isMillBinsGroup = org => org?.getSubEntityByRel('https://api.binsentry.com/rel/organization-type')?.properties.name === 'mill-bins-group';
const isAccount = org => org?.getSubEntityByRel('https://api.binsentry.com/rel/organization-type')?.properties.name === 'account';

const canHaveMillBinGroupChild = (org) => {
  if (!isAccount(org)) {
    return false;
  }
  return org?.properties.structure?.['mill-bins-group'];
};

export function useMillBinsGroup() {
  const { currentOrgHref, queryV2 } = useStore(['currentOrgHref', 'queryV2']);
  const orgId = queryV2?.organizationId || queryV2?.orgId || currentOrgHref;

  const { result: millBinsGroup, loading } = useAsyncFetch(async () => {
    const organizationEntity = parseSiren((await entityStore.fetchWait(orgId, false)).entity);
    const orgIsBinsGroup = isMillBinsGroup(organizationEntity);
    if (orgIsBinsGroup) {
      return organizationEntity;
    }

    if (!canHaveMillBinGroupChild(organizationEntity)) {
      return undefined;
    }

    // Check paginated organization children for mill-bins-group type
    let currentHref = organizationEntity?.getSubEntityByRel('https://api.binsentry.com/rel/organization-children')?.href;
    while (currentHref) {
      const organizationChildrenEntity = parseSiren((await entityStore.fetchWait(currentHref, false)).entity);

      const millBinsGroup = organizationChildrenEntity?.getSubEntities('item').find(isMillBinsGroup);
      if (millBinsGroup) {
        return millBinsGroup;
      }

      currentHref = organizationChildrenEntity?.getLink('next')?.href;
    }

    return undefined;
  }, [orgId]);

  return { millBinsGroup, loading };
}
